import tippy from 'tippy.js';

export default function () {
  tippy('[data-tippy-content]');
}
